var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _path3, _path4, _path5, _path6, _rect12, _rect13, _rect14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 155,
    viewBox: "0 0 250 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 137.566,
    y: 33.0596,
    width: 112.092,
    height: 23.7772,
    rx: 11.8886,
    fill: "#DCEBFE",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.383,
    y: 130.206,
    width: 57.0652,
    height: 23.7772,
    rx: 11.8886,
    fill: "#DCEBFE",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.339844,
    y: 86.0488,
    width: 57.0652,
    height: 23.7772,
    rx: 11.8886,
    fill: "#DCEBFE",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7578,
    y: 37.1357,
    width: 17.663,
    height: 9.51087,
    rx: 4.75543,
    fill: "#DCEBFE",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6875,
    y: 27.624,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#8FFF9B",
    fillOpacity: 0.38
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9727,
    y: 69.0654,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#FF8F8F",
    fillOpacity: 0.38
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.426,
    y: 24.2275,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#DBFF8F",
    fillOpacity: 0.38
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4648,
    y: 54.1191,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#DBFF8F",
    fillOpacity: 0.38
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.82,
    y: 91.4834,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#FF8FC5",
    fillOpacity: 0.38
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 176.289,
    y: 69.0654,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#9F8FFF",
    fillOpacity: 0.38
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4062,
    y: 116.619,
    width: 5.43478,
    height: 5.43478,
    rx: 2.71739,
    fill: "#9F8FFF",
    fillOpacity: 0.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.445 87.6621H163.383V53.6948C163.383 32.6244 146.24 15.4814 125.17 15.4814C104.1 15.4814 86.9567 32.6244 86.9567 53.6948V87.6621H85.8952C83.9252 87.6643 82.0365 88.4479 80.6436 89.8409C79.2506 91.2339 78.467 93.1225 78.4648 95.0925V139.675C78.467 141.645 79.2506 143.533 80.6436 144.926C82.0365 146.319 83.9252 147.103 85.8952 147.105H164.445C166.415 147.103 168.303 146.319 169.696 144.926C171.089 143.533 171.873 141.645 171.875 139.675V95.0925C171.873 93.1225 171.089 91.2339 169.696 89.8409C168.303 88.4479 166.415 87.6643 164.445 87.6621ZM91.2026 53.6948C91.2026 44.686 94.7813 36.0463 101.151 29.6762C107.522 23.3061 116.161 19.7274 125.17 19.7274C134.179 19.7274 142.818 23.3061 149.189 29.6762C155.559 36.0463 159.137 44.686 159.137 53.6948V87.6621H150.646V53.6948C150.646 46.9382 147.962 40.4584 143.184 35.6808C138.406 30.9032 131.927 28.2192 125.17 28.2192C118.413 28.2192 111.934 30.9032 107.156 35.6808C102.378 40.4584 99.6945 46.9382 99.6945 53.6948V87.6621H91.2026V53.6948ZM146.4 53.6948V87.6621H103.94V53.6948C103.94 48.0643 106.177 42.6645 110.158 38.6832C114.14 34.7018 119.54 32.4651 125.17 32.4651C130.8 32.4651 136.2 34.7018 140.182 38.6832C144.163 42.6645 146.4 48.0643 146.4 53.6948ZM167.629 139.675C167.629 140.519 167.293 141.329 166.696 141.926C166.099 142.523 165.289 142.858 164.445 142.859H85.8952C85.0509 142.858 84.2413 142.523 83.6442 141.926C83.0472 141.329 82.7115 140.519 82.7108 139.675V95.0925C82.7115 94.2482 83.0472 93.4386 83.6442 92.8416C84.2413 92.2445 85.0509 91.9088 85.8952 91.9081H164.445C165.289 91.9088 166.099 92.2445 166.696 92.8416C167.293 93.4386 167.629 94.2482 167.629 95.0925V139.675Z",
    fill: "#1273B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9589 98.2762C88.1314 98.2762 89.0819 97.3257 89.0819 96.1532C89.0819 94.9808 88.1314 94.0303 86.9589 94.0303C85.7864 94.0303 84.8359 94.9808 84.8359 96.1532C84.8359 97.3257 85.7864 98.2762 86.9589 98.2762Z",
    fill: "#1273B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9589 140.736C88.1314 140.736 89.0819 139.786 89.0819 138.613C89.0819 137.441 88.1314 136.49 86.9589 136.49C85.7864 136.49 84.8359 137.441 84.8359 138.613C84.8359 139.786 85.7864 140.736 86.9589 140.736Z",
    fill: "#1273B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.385 98.2762C164.557 98.2762 165.508 97.3257 165.508 96.1532C165.508 94.9808 164.557 94.0303 163.385 94.0303C162.212 94.0303 161.262 94.9808 161.262 96.1532C161.262 97.3257 162.212 98.2762 163.385 98.2762Z",
    fill: "#1273B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.385 140.736C164.557 140.736 165.508 139.786 165.508 138.613C165.508 137.441 164.557 136.49 163.385 136.49C162.212 136.49 161.262 137.441 161.262 138.613C161.262 139.786 162.212 140.736 163.385 140.736Z",
    fill: "#1273B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.169 102.522C122.942 102.522 120.77 103.223 118.963 104.526C117.156 105.829 115.804 107.667 115.099 109.781C114.395 111.894 114.373 114.176 115.038 116.302C115.702 118.429 117.018 120.292 118.801 121.629V130.121C118.801 131.81 119.472 133.43 120.666 134.624C121.86 135.819 123.48 136.49 125.169 136.49C126.859 136.49 128.479 135.819 129.673 134.624C130.867 133.43 131.538 131.81 131.538 130.121V121.629C133.321 120.292 134.637 118.429 135.301 116.302C135.966 114.176 135.944 111.894 135.24 109.781C134.535 107.667 133.183 105.829 131.376 104.526C129.569 103.223 127.397 102.522 125.169 102.522ZM128.352 118.657C128.03 118.843 127.763 119.111 127.577 119.433C127.391 119.756 127.293 120.121 127.292 120.493V130.121C127.292 130.684 127.069 131.224 126.671 131.622C126.273 132.02 125.733 132.244 125.169 132.244C124.606 132.244 124.066 132.02 123.668 131.622C123.27 131.224 123.047 130.684 123.047 130.121V120.493C123.047 120.121 122.949 119.755 122.763 119.433C122.577 119.11 122.309 118.842 121.987 118.656C120.772 117.955 119.823 116.873 119.286 115.578C118.749 114.282 118.655 112.846 119.017 111.492C119.38 110.137 120.18 108.94 121.292 108.087C122.404 107.233 123.767 106.77 125.169 106.77C126.572 106.77 127.935 107.233 129.047 108.087C130.159 108.94 130.959 110.137 131.322 111.492C131.684 112.846 131.59 114.282 131.053 115.578C130.516 116.873 129.567 117.955 128.352 118.656V118.657Z",
    fill: "#1273B7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 146.398,
    y: 0.450195,
    width: 2.71739,
    height: 14.9457,
    rx: 1.3587,
    fill: "#1273B7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 161.996,
    y: 5.88477,
    width: 2.71739,
    height: 14.9457,
    rx: 1.3587,
    transform: "rotate(50.4438 161.996 5.88477)",
    fill: "#1273B7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 169.473,
    y: 18.1133,
    width: 2.71739,
    height: 14.9457,
    rx: 1.3587,
    transform: "rotate(86.8083 169.473 18.1133)",
    fill: "#1273B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.93f835d36f288e6e7a006544a7eab2ab.svg";
export { ForwardRef as ReactComponent };